import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6a83480d")
const _hoisted_1 = { class: "content" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "slide",
    onAfterLeave: _ctx.handleTransitionEnd
  }, {
    default: _withCtx(() => [
      (_ctx.showToast)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "toast",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissToast && _ctx.dismissToast(...args)))
          }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.content), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onAfterLeave"]))
}